import { createRouter, createWebHistory } from "vue-router";
import UserList from "../views/user/UserList.vue";
import UserUpdate from "../views/user/UserUpdate.vue";
import UserCreate from "../views/user/UserCreate.vue";
import ChangePassword from "../views/user/ChangePassword.vue";
import UserProfile from "../views/user/UserProfile.vue";
import NoPageFound from "../views/NoPageFound.vue";
import NaturalList from "../views/natural/NaturalList.vue";
import NaturalDetails from "../views/natural/NaturalDetails.vue";
import NaturalUpdate from "../views/natural/NaturalUpdate.vue";
import NaturalCreate from "../views/natural/NaturalCreate.vue";
import PostList from "../views/post/PostList";
import PostCreate from "../views/post/PostCreate";
import PostUpdate from "../views/post/PostUpdate";
import PostDetails from "../views/post/PostDetails";
import TrailList from "../views/trails/TrailList.vue";
import TrailCreate from "../views/trails/TrailCreate.vue";
import TrailUpdate from "../views/trails/TrailUpdate.vue";
import TrailDetails from "../views/trails/TrailDetails.vue";
import Dashboard from "../views/dashboard/Dashboard";
import {isAuthenticatedGuard, isGestor, isSuperAdmin} from "../services/authGuard";
import PointDetails from "../views/points/PointDetails.vue";
import PointList from "../views/points/PointList.vue";
import PointUpdate from "../views/points/PointUpdate.vue";
import PointCreate from "../views/points/PointCreate.vue";
import RecuperatePassword from "../views/user/RecuperatePassword.vue";
import ExperienceList from "../views/experience/ExperienceList.vue";
import ExperienceDetails from "../views/experience/ExperienceDetails.vue";
import ExperienceUpdate from "../views/experience/ExperienceUpdate.vue";
import ExperienceCreate from "../views/experience/ExperienceCreate.vue";
import ReserveCreate from "../views/reserves/ReserveCreate.vue";
import ReserveUpdate from "../views/reserves/ReserveUpdate.vue";
import ReserveDetails from "../views/reserves/ReserveDetails.vue";
import ReserveList from "../views/reserves/ReserveList.vue";
import ExperienceTypeDetails from "../views/experience_type/ExperienceTypeDetails.vue";
import ExperienceTypeUpdate from "../views/experience_type/ExperienceTypeUpdate.vue";
import ExperienceTypeList from "../views/experience_type/ExperienceTypeList.vue";
import ExperienceTypeCreate from "../views/experience_type/ExperienceTypeCreate.vue";
import ChangeUserPassword from "../views/user/ChangeUserPassword.vue";




const routes = [
    {
        path: '/login',
        name: 'Login',
        component: () => import('../views/LoginUser'),
    },
    {
        path: "/confirm/recuperate-password/:token",
        name: "Recuperar-Contraseña",
        component: RecuperatePassword
    },
    {
        path: '/',
        name: 'Front',
        component: () => import('../layouts/MainLayout'),
        children: [
            {
                path: "/",
                name: "Dashboard",
                component: Dashboard,
                beforeEnter: [isAuthenticatedGuard]
            },
            {
                path: "/users",
                name: "Usuarios",
                component: UserList,
                beforeEnter: [isSuperAdmin]
            },
            {
                path: "users/:id",
                name: "Actualizar-Usuario",
                component: UserUpdate,
                beforeEnter: [isSuperAdmin]
            },
            {
                path: "users/add",
                name: "Crear-Usuario",
                component: UserCreate,
                beforeEnter: [isSuperAdmin]
            },
            {
                path: "users/edit/:id",
                name: "Cambiar-Contraseña",
                component: ChangePassword
            },
            {
                path: "user/profile/edit/:id",
                name: "Editar-Perfil",
                component: UserProfile,
                beforeEnter: [isSuperAdmin]
            },
            {
                path: "/naturals",
                name: "Natural",
                component: NaturalList,
                beforeEnter: [isGestor]
            },
            {
                path: "naturals/detail/:id",
                name: "Detalle-Natural",
                component: NaturalDetails,
                beforeEnter: [isGestor]
            },
            {
                path: 'naturals/:id',
                name: 'Actualizar-Natural',
                component: NaturalUpdate,
                beforeEnter: [isGestor]
            },
            {
                path: 'naturals/add',
                name: 'Crear-Natural',
                component: NaturalCreate,
                beforeEnter: [isGestor]
            },
            {
                path: "/trails",
                name: "Senderos",
                component: TrailList,
                beforeEnter: [isGestor]
            },
            {
                path: "trails/detail/:id",
                name: "Detalle-Sendero",
                component: TrailDetails,
                beforeEnter: [isGestor]
            },
            {
                path: 'trails/:id',
                name: 'Actualizar-Sendero',
                component: TrailUpdate,
                beforeEnter: [isGestor]
            },
            {
                path: 'trails/add',
                name: 'Crear-Sendero',
                component: TrailCreate,
                beforeEnter: [isGestor]
            },
            {
                path: "/experiences",
                name: "Experiencias",
                component: ExperienceList,
                beforeEnter: [isGestor]
            },
            {
                path: "experiences/detail/:id",
                name: "Detalle-Experiencia",
                component: ExperienceDetails,
                beforeEnter: [isGestor]
            },
            {
                path: 'experiences/:id',
                name: 'Actualizar-Experiencia',
                component: ExperienceUpdate,
                beforeEnter: [isGestor]
            },
            {
                path: 'experiences/add',
                name: 'Crear-Experiencia',
                component: ExperienceCreate,
                beforeEnter: [isGestor]
            },
            {
                path: "/experience_types",
                name: "TipoExperiencias",
                component: ExperienceTypeList,
                beforeEnter: [isGestor]
            },
            {
                path: "experience_types/detail/:id",
                name: "Detalle-TipoExperiencia",
                component: ExperienceTypeDetails,
                beforeEnter: [isGestor]
            },
            {
                path: 'experience_types/:id',
                name: 'Actualizar-TipoExperiencia',
                component: ExperienceTypeUpdate,
                beforeEnter: [isGestor]
            },
            {
                path: 'experience_types/add',
                name: 'Crear-TipoExperiencia',
                component: ExperienceTypeCreate,
                beforeEnter: [isGestor]
            },
            {
                path: "/points",
                name: "Puntos",
                component: PointList,
                beforeEnter: [isGestor]
            },
            {
                path: "points/detail/:id",
                name: "Detalle-Punto",
                component: PointDetails,
                beforeEnter: [isGestor]
            },
            {
                path: 'points/:id',
                name: 'Actualizar-Punto',
                component: PointUpdate,
                beforeEnter: [isGestor]
            },
            {
                path: 'points/add',
                name: 'Crear-Punto',
                component: PointCreate,
                beforeEnter: [isGestor]
            },
            {
                path: "/news",
                name: "Noticias",
                component: PostList,
                beforeEnter: [isGestor]
            },
            {
                path: "news/detail/:id",
                name: "Detalle-Noticia",
                component: PostDetails,
                beforeEnter: [isGestor]
            },
            {
                path: 'news/:id',
                name: 'Actualizar-Noticia',
                component: PostUpdate,
                beforeEnter: [isGestor]
            },
            {
                path: 'news/add',
                name: 'Crear-Noticia',
                component: PostCreate,
                beforeEnter: [isGestor]
            },
            {
                path: "/reserves",
                name: "Reservas",
                component: ReserveList,
                beforeEnter: [isSuperAdmin]
            },
            {
                path: "reserves/detail/:id",
                name: "Detalle-Reserva",
                component: ReserveDetails,
                beforeEnter: [isSuperAdmin]
            },
            {
                path: 'reserves/:id',
                name: 'Actualizar-Reserva',
                component: ReserveUpdate,
                beforeEnter: [isSuperAdmin]
            },
            {
                path: 'reserves/add',
                name: 'Crear-Reserva',
                component: ReserveCreate,
                beforeEnter: [isSuperAdmin]
            },
            {
                path: "users/edit/:id",
                name: "Cambiar-Contraseña",
                component: ChangePassword
            },
            {
                path: "users/change-password/:id",
                name: "Cambiar-Contraseña-Usuario",
                component: ChangeUserPassword
            },
        ]
    },
    {
        path: '/:pathMatch(.*)*',
        component: NoPageFound
    },

];

const router = createRouter({
    history: createWebHistory(),
    routes,
    linkActiveClass: "active",
});

export default router;
